import(/* webpackMode: "eager", webpackExports: ["default"] */ "/tmp/8de4e9f39ca2c4f/components/sections/CtaSection.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["FAQSection"] */ "/tmp/8de4e9f39ca2c4f/components/sections/FAQSection.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/tmp/8de4e9f39ca2c4f/components/sections/FeaturesCarousel.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/tmp/8de4e9f39ca2c4f/components/sections/IntegrationsSection.tsx");
;
import(/* webpackMode: "eager" */ "/tmp/8de4e9f39ca2c4f/components/sections/InternalLinksSection.module.css");
;
import(/* webpackMode: "eager", webpackExports: ["KioskFeatures"] */ "/tmp/8de4e9f39ca2c4f/components/sections/KioskFeatures.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["QRCaseStudy"] */ "/tmp/8de4e9f39ca2c4f/components/sections/QRCaseStudy.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["WebshopShowcase"] */ "/tmp/8de4e9f39ca2c4f/components/sections/WebshopShowcase.tsx");
;
import(/* webpackMode: "eager" */ "/tmp/8de4e9f39ca2c4f/components/ui/Section.module.css");
;
import(/* webpackMode: "eager" */ "/tmp/8de4e9f39ca2c4f/components/ui/Container.module.css");
;
import(/* webpackMode: "eager" */ "/tmp/8de4e9f39ca2c4f/components/ui/Heading.module.css");
;
import(/* webpackMode: "eager" */ "/tmp/8de4e9f39ca2c4f/components/ui/Text.module.css");
;
import(/* webpackMode: "eager" */ "/tmp/8de4e9f39ca2c4f/node_modules/next/dist/client/link.js");
